import { AnalyticsFilterService } from './analytics-filter.service';

export default angular
  .module('sfMobile.services.analytics-filter', ['sfMobile.services.dates'])
  .service('analyticsFilterService', AnalyticsFilterService).name;
